var _g, _circle, _g2, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgApplicationsuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 192,
    height: 191,
    viewBox: "0 0 192 191",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.12,
    filter: "url(#filter0_f_187_3494)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M183.519 95.3009C183.519 143.736 144.255 183 95.82 183C47.3852 183 8.12109 143.736 8.12109 95.3009C8.12109 46.8662 47.3852 7.60205 95.82 7.60205C144.255 7.60205 183.519 46.8662 183.519 95.3009ZM15.6757 95.3009C15.6757 139.563 51.5575 175.445 95.82 175.445C140.082 175.445 175.964 139.563 175.964 95.3009C175.964 51.0385 140.082 15.1566 95.82 15.1566C51.5575 15.1566 15.6757 51.0385 15.6757 95.3009Z",
    fill: "#1F1F1F",
    fillOpacity: 0.6
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 95.7454,
    cy: 89.9564,
    r: 82.9564,
    fill: "url(#paint0_radial_187_3494)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.75,
    filter: "url(#filter1_i_187_3494)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M183.519 95.3009C183.519 143.736 144.255 183 95.82 183C47.3852 183 8.12109 143.736 8.12109 95.3009C8.12109 46.8662 47.3852 7.60205 95.82 7.60205C144.255 7.60205 183.519 46.8662 183.519 95.3009ZM15.6757 95.3009C15.6757 139.563 51.5575 175.445 95.82 175.445C140.082 175.445 175.964 139.563 175.964 95.3009C175.964 51.0385 140.082 15.1566 95.82 15.1566C51.5575 15.1566 15.6757 51.0385 15.6757 95.3009Z",
    fill: "url(#paint1_radial_187_3494)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57.7793 100.126L78.1008 120.448L83.2266 115.286L62.9415 95.0004M137.139 71.6616L98.6767 110.16L83.5538 95.0004L78.3553 100.126L98.6767 120.448L142.301 76.8238M121.725 76.8238L116.599 71.6616L93.5146 94.746L98.6767 99.8718L121.725 76.8238Z",
    fill: "#71F185"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_187_3494",
    x: 0.599726,
    y: 0.0806832,
    width: 190.441,
    height: 190.441,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.76068,
    result: "effect1_foregroundBlur_187_3494"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_187_3494",
    x: 8.12109,
    y: 7.60205,
    width: 175.398,
    height: 176,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.903336
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.301112
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.443137 0 0 0 0 0.945098 0 0 0 0 0.521569 0 0 0 0.22 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_187_3494"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_187_3494",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(95.7454 89.9564) rotate(90) scale(82.9564)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.637785,
    stopColor: "#060606",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3A3A3A",
    stopOpacity: 0.17
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_187_3494",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(95.82 95.3009) rotate(90) scale(87.6989)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.930858,
    stopColor: "#161616",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#161616"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApplicationsuccess);
export default __webpack_public_path__ + "static/media/applicationsuccess.ac05f791bbe0cbf80fccc0ba9ff18dda.svg";
export { ForwardRef as ReactComponent };